import { render, staticRenderFns } from "./VasPayment.vue?vue&type=template&id=b8629224&scoped=true&"
import script from "./VasPayment.vue?vue&type=script&lang=ts&"
export * from "./VasPayment.vue?vue&type=script&lang=ts&"
import style0 from "./VasPayment.vue?vue&type=style&index=0&id=b8629224&scoped=true&lang=css&"
import style1 from "./VasPayment.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8629224",
  null
  
)

export default component.exports